import React, { useEffect } from "react";
import "./HelpSectionCommunity.scss";
import { connect } from 'react-redux';
import { getHelpSectionData } from '../../../store/actions/CommunityAction';

const HelpSectionCommunity = (props) => {

    const { getHelpSectionData, helpData } = props;
    
    useEffect(() => {
        try {
            getHelpSectionData()
        } catch (error) {
            console.log('error', error);
        }
    }, [])

    return (
        <div className="contentMainHelp">
            <div className="contentMainHelp_title">Estamos para ayudarte</div>
            <div className='contentMainHelp_elem'>
                <img src='/img/community/helpSection/profile.svg' alt='icon' className='contentMainHelp_img'/>
                <div className='contentMainHelp_container'>
                    <p className='contentMainHelp_number'>
                        {helpData && helpData.totalLawyer ?
                            helpData.totalLawyer : 0
                        }
                    </p>
                    <p className='contentMainHelp_text'>abogados a tu disposición</p>
                </div>
            </div>
            <div className='contentMainHelp_elem'>
                <img src='/img/community/helpSection/questions.svg' alt='icon' className='contentMainHelp_img'/>
                <div className='contentMainHelp_container'>
                    <p className='contentMainHelp_number'>
                        {helpData && helpData.totalQuestions ?
                            helpData.totalQuestions : 0
                        }
                    </p>
                    <p className='contentMainHelp_text'>preguntas realizadas</p>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    helpData: state.communityReducer.helpData,
})

const mapDispatchToProps = dispatch => ({
    getHelpSectionData: () => dispatch(getHelpSectionData())
})

export default connect(mapStateToProps, mapDispatchToProps)(HelpSectionCommunity);

